import React from "react";
import "./confinedSpaceAllTemplate.css";

const Template7CS = () => {
  return (
    <div className="cs_template-container">
      <div className="template-container-content underline-bottom">
        <div className="template-container-pera">
          <div className="cold-remark">
            <div className="template-heading">
              सामान्य अनुदेश / General Instruction
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>1.</span>
              <div>
                कार्य की अनुमति पत्र को स्पष्ट रूप से और साफ अक्षरों में भरा
                जाएगा, ताकि यह सुनिश्चित हो सके कि सभी अनुभागों / उपखंडों में
                पूरी जानकारी दी गई है। किसी भी गलत संचार से बचने के लिए जो भी
                संभव हो प्रदान किया जाना चाहिए।
                The work permit shall be filled up carefully and accurately in
                clear handwriting ensuring that complete information is provided
                in all sections / subsections and none of column is blank.
                Sketches wherever possible to avoid miscommunication.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>2.</span>
              <div>
                उपयुक्त सुरक्षा उपायों और कर्मचारियों के व्यक्तिगत सुरक्षा
                उपकरण (PPEs) को संभावित खतरों और कार्य प्रारंभ करने से पहले किये
                जाने वाले संचालन के सावधानीपूर्वक विश्लेषण द्वारा निर्धारित किया
                जाएगा।
                Appropriate safeguards and required personal protective
                equipment (PPEs) shall be determined by a careful analysis of the
                potential hazards and operation to be performed prior to starting
                the work.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>3.</span>
              <div>
                यदि प्रक्रिया / रखरखाव / ठेकेदार / अग्नि / सुरक्षा विभाग से किसी
                भी अतिरिक्त आवश्यकता हो तो उसे विशेष आवश्यकता में उल्लेख किया
                जाएगा।
                Requirement of standby personnel from Process / Maintenance /
                Contractor / Fire / Safety etc. if any shall be mentioned in the
                additional requirement.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>4.</span>
              <div>
                आग की चेतावनी / सायरन होने पर सभी कार्य तुरंत बंद कर दिए जाएं।
                In case of alarm/siren, all work must immediately be stopped.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>5.</span>
              <div>
                केवल प्रमाणित वाहनों / इंजनों और अनुमत उपकरणों का उपयोग किया
                जाएगा।
                Only certified vehicle / engines and permitted equipment and
                tools are allowed.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>6.</span>
              <div>
                कोई भी गरम कार्य तब तक नहीं किया जाएगा जब तक कि कार्य स्थल के
                आस-पास का क्षेत्र ज्वलनशील पदार्थों से मुक्त नहीं हो जाता।
                No hot work should be permitted unless the work area is free from
                hazardous and exhausted gases.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>7.</span>
              <div>
                वेल्डिंग मशीन को किसी भी पात्र या संवृत स्थान (वेसल) के अंदर नहीं
                रखा जाएगा।
                Welding machine should be located at non-hazardous area outside
                the vessel.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>8.</span>
              <div>
                जब कोई व्यक्ति किसी पात्र के अंदर प्रवेश करता है, तो उसका
                प्रवेश-द्वार हमेशा खुला रहना चाहिए और बाहर रहने वाले पर्यवेक्षक
                द्वारा सुरक्षित किया जाना चाहिए।
                When a person enters inside the vessel, the manhole or opening of
                any vessel must be kept open and safeguarded by the attendant
                standing outside the vessel.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>9.</span>
              <div>
                कार्य निकासी के नवीनीकरण हेतु जारीकर्ता यह सुनिश्चित करेगा कि
                कार्य को जारी रखने की स्थिति संतोषजनक है। यदि परिस्थितियाँ बदल
                गई हैं तो नया अनुमति पत्र जारी किया जाएगा अथवा मौजूदा परमिट में
                संशोधन किया जाएगा।
                For renewal of work clearance, the issuer shall ensure that the
                conditions are satisfactory for the work to continue. If the
                conditions have changed, it may be necessary to issue a new permit
                or amend the existing permit.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>10.</span>
              <div>
                यह अनुमति पत्र उसी अनुमति पत्र पर अधिकतम सात कैलेंडर दिनों तक
                नवीनीकृत या विस्तारित किया जा सकता है।
                This clearance on the same permit can be renewed / extended up to
                a maximum of seven calendar days.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>11.</span>
              <div>
                यह अनुमति पत्र कार्य स्थल पर हमेशा उपलब्ध रहना चाहिए।
                This permit must be available at work site at all times.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>12.</span>
              <div>
                काम पूरा होने पर अनुमति पत्र बंद कर दिया जाएगा और रिकॉर्ड के रूप
                में रखा जाएगा।
                On completion of the work, the permit shall be closed and kept as
                record.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>13.</span>
              <div>
                संचालन और रखरखाव प्रथाओं के आधार पर अतिरिक्त निर्देश।
                The additional instruction based on operating and maintenance
                practices.
              </div>
            </div>

            <div className="pera-flex">
              <span style={{ width: "50px", paddingRight: "26px" }}>14.</span>
              <div>
                उसी दिन के कार्य अनुमति पत्र को केवल सुरक्षा अधिकारी से परामर्श
                के बाद ही विस्तारित किया जाएगा।
                In case of permit extension for the same day, permit to be
                extended only after consulting with the safety officer.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template7CS;